var map = {
	"./TestDataArea_2_Multiple_Layered.PNG": 5145,
	"./TestDataArea_4_Multiple_Stacked.PNG": 2655,
	"./TestDataBar_1_Simple.PNG": 7807,
	"./TestDataBar_2Y.PNG": 6757,
	"./TestDataBar_4_GradientColor.PNG": 3350,
	"./TestDataBar_5_PosNegColor.PNG": 9395,
	"./TestDataBar_6_Transparancy.PNG": 1721,
	"./TestDataBar_FontFun.PNG": 2286,
	"./TestDataBar_MultiBar_SideBySide.PNG": 2977,
	"./TestDataBar_MultiBar_Stacked.PNG": 9486,
	"./TestDataBubble_1_guns.PNG": 756,
	"./TestDataBubble_2_series.PNG": 8807,
	"./TestDataGrids_3_alternateGridFillX.PNG": 6600,
	"./TestDataGrids_4_alternateGridFillY.PNG": 2625,
	"./TestDataGrids_5_Gradiant.PNG": 1398,
	"./TestDataLog_1.PNG": 8969,
	"./TestDataPieBubble.PNG": 9489,
	"./TestDataPie_Multi.PNG": 5269,
	"./TestDataPie_SimplePie.PNG": 4561,
	"./TestDataXY_Boxplot.PNG": 3393,
	"./TestDataXY_CandlePlot.PNG": 9646,
	"./TestDataXY_LineExamples.PNG": 1397,
	"./TestDataXY_Math.PNG": 6627,
	"./TestDataXY_Polynomals.PNG": 9975,
	"./TestDataXY_Scatter.PNG": 1838,
	"./TestDataXY_Simple.PNG": 1037,
	"./TestDataXY_Simple_Series.PNG": 3472,
	"./TestDataXY_SineCurve.PNG": 4901,
	"./TestStackedChart2.PNG": 1304,
	"./TestStackedChart3.PNG": 1306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3541;